import { useEffect, useState } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Authorization from './pages/Authorization';
import Main from './pages/Main';
import Certificates from './pages/Certificates';
import Snils from './pages/Snils';
import Admin from './pages/Admin';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import DispensaryObservation from './pages/DispensaryObservation';
import Reporting from './pages/Reporting/index';
import Box from '@mui/material/Box';

const tokenTime = localStorage.getItem('token_time');
const todayIs = new Date().toISOString();

const App = () => {
    const { pathname } = useLocation();

    const [isAuthorize, setIsAuthorize] = useState(false);
    const [autorizedPerson, setAutorizedPerson] = useState(localStorage.getItem('fioAndOrganization'));
    const tokenBestBefore =
        tokenTime && new Date(new Date(tokenTime).setMinutes(new Date(tokenTime).getMinutes() + 180)).toISOString();

    useEffect(() => {
        if (tokenBestBefore && tokenBestBefore < todayIs) {
            localStorage.clear();
        }
    }, [tokenBestBefore]);

    const isAuth = (value: boolean) => setIsAuthorize(value);

    const getFioAndOrganization = (fioAndOrganization: string) => setAutorizedPerson(fioAndOrganization);

    return (
        <Box m={-1}>
            <Routes>
                <Route
                    path='/'
                    element={
                        !!tokenBestBefore || isAuthorize ? (
                            <Main getFioAndOrganization={getFioAndOrganization} />
                        ) : (
                            <Navigate to='/login' />
                        )
                    }
                />
                <Route
                    path='/login'
                    element={<Authorization isAuth={isAuth} getFioAndOrganization={getFioAndOrganization} />}
                />
                <Route path='/certificates' element={<Certificates />} />
                <Route path='/largeFamilies' element={<Snils />} />
                <Route
                    path='/admin'
                    element={!!tokenBestBefore || isAuthorize ? <Admin /> : <Navigate to='/login' />}
                />
                <Route path='/dispensary' element={<DispensaryObservation />} />
                <Route path='/reporting' element={<Reporting />} />
            </Routes>
            {autorizedPerson && pathname !== '/' && (
                <Paper
                    sx={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: '20px',
                        display: 'flex',
                        justifyContent: 'end',
                        paddingRight: 3,
                        alignItems: 'center',
                        borderTop: 1,
                        borderColor: 'divider',
                    }}
                >
                    <Typography variant='caption'>{autorizedPerson}</Typography>
                </Paper>
            )}
        </Box>
    );
};
export default App;
